const SLUGS = [
	{ title: "Home", path: "/" },
	{
		title: "About us",
		path: "/about-us",
		subcategory: [
			{ title: "Our Team", path: "/about-us/our-team" },
			{ title: "Our Story", path: "/about-us/our-story" },
			{ title: "Our Programs", path: "/about-us/our-programs" },
			{
				title: "Our Mission, Vision and Purpose",
				path: "/about-us/our-mission-vision-purpose",
			},
		],
		menuState: 'about-us-menu'
	},
	{ title: "Events", path: "/events" },
	{
		title: "Get Involved",
		path: "/get-involved",
		subcategory: [
			{ title: "Become a Volunteer", path: "/get-involved/#volunteer" },
			{ title: "Become a Partner", path: "/get-involved/#partner" },
			{
				title: "Register your Community",
				path: "/get-involved/#community",
			},
		],
		menuState: 'get-involved-menu'
	},
	// {
	// 	title: "Outreach",
	// 	path: "/outreach/prayer-request",
	// 	subcategory: [
	// 		{ title: "Prayer Request", path: "/outreach/prayer-request" },
	// 		{ title: "Devotional", path: "/outreach/devotional" },
	// 		{
	// 			title: "How to know Jesus",
	// 			path: "/outreach/how-to-know-Jesus",
	// 		},
	// 	],
	// 	menuState: 'outreach'
	// },
	{ title: "Mentorship", path: "/mentorship" },
	{
		title: "Connect with us",
		path: "/connect-with-us",
		subcategory: [
			{ title: "Contact us", path: "/connect-with-us/contact-us" },
			{ title: "Media room", path: "/connect-with-us/media-room" },
			{ title: "Blog", path: "https://3hfoundation.medium.com/" },
		],
		menuState: 'connect-with-us'
	},
	{ title: "Donate", path: "/donate" },
];

export default SLUGS;
